export default __webpack_public_path__ + "static/media/KK_R_Left_Top_s-cropped.199e6cc7.svg";